import { usersConstants } from "../../actions/users/index";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  }
};

export default function user(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case usersConstants.LOAD_USER_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      user: null
    };
  case usersConstants.LOAD_USER_SUCCESS:
    return {
      ...payload,
      status: {
        ...payload.status,
        started: false,
        error: false,
        ended: true
      }
    };
  case usersConstants.LOAD_USER_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false,
        errorInfo: { code: payload.code, message: payload.message }
      }
    };
  case "UPDATE_LOGIN_DATA_USER":
    return {
      ...payload,
      status: {
        started: false,
        error: false,
        ended: true
      }
    };
  default:
    return defaultS;
  }
}
